<template>
  <div class="attendance-setting">
    <div class="search">
      <el-select v-model="department" class="gray" placeholder="请选择部门">
        <el-option
          v-for="item in departmentList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        class="gray"
        v-model="date"
        type="month"
        placeholder="选择月"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button class="btn-blue" @click="searchData">搜索</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="员工"></el-table-column>
        <el-table-column prop="days" label="当月应出勤天数">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputDays(scope.$index, scope.row.days)"
              v-model="scope.row.days"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              type="text"
              @click="saveAttendance(scope.row)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getInteger, modifyNetTitle } from "common/js/util";
import Employee from "models/employee";
const employee = new Employee();
export default {
  data() {
    return {
      department: "",
      date: "",
      departmentList: [],
      tableData: []
    };
  },
  created() {
    modifyNetTitle('出勤设置')
    this.getCompanyList();
    this.getTableData();
  },
  methods: {
    //获取部门数据
    getCompanyList() {
      employee.getDeptList().then(res => {
        let departmentList = [];
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            departmentList.push(obj);
          });
          this.departmentList = departmentList;
        }
      });
    },
    getTableData() {
      let deptId = this.department;
      let date = this.date;
      employee.getAttendanceList(deptId, date).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.employeeId = value.employeeId;
            obj.name = value.employeeName;
            obj.days = value.days;
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    searchData() {
      if (this.department && this.date) {
        this.getTableData();
      } else {
        this.$message.error("请选择部门和月份");
      }
    },
    saveAttendance(row) {
      let data = {};
      data.employeeId = row.employeeId;
      data.date = this.date;
      data.days = row.days;
      employee.postAddAttendance(data).then(res => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            type: "success",
            duration: 1000
          });
          this.getTableData();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000
          });
          this.getTableData();
        }
      });
    },
    //限制天数输入
    inputDays(index, days) {
      let daysNum = getInteger(days);
      this.tableData[index].days = daysNum;
    }
  }
};
</script>
<style lang="scss" scoped>
.attendance-setting {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    .el-select {
      margin-right: 16px;
    }
    .btn-blue {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
}
</style>
<style lang="scss">
.attendance-setting {
  .table {
    .el-table {
      .el-input {
        width: 110px;
        .el-input__inner {
          height: 24px;
          width: 110px;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
